import { createFileRoute } from '@tanstack/react-router'
import AccountVerified from 'features/Auth/AccountVerify/AccountVerified.component'

export const Route = createFileRoute('/(auth)/_auth/account-verified')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AccountVerified />
}
